<template>
  <div id="app">
    <router-view />
    <AppNotifications />
  </div>
</template>

<script>
import AppNotifications from './components/AppNotifications.vue'

export default {
  name: 'App',
  components: { AppNotifications },
}
</script>
